<template>
	<Dialog modal :header="header != null && header != ''  ? header : 'Confirmation'" v-model:visible="isVisible" :style="{width: '40vw'}" @hide="cancel">
		<div>
			<div class="row">
				<div class="col-md-12 d-flex">
					<i class="mr-3 align-self-center" :class="icon != null && icon != '' ? icon : 'pi pi-exclamation-triangle'" style="font-size: 1.5rem;" />
					<span>{{ message }}</span>
				</div>

				<div class="col-md-12 mt-3" v-if="withRemarks">
					<Textarea v-model="returnObj.remarks" :autoResize="true" rows="5" cols="30" maxlength="255" placeholder="Remarks" autofocus />
				</div>

			</div>
		</div>

		<template #footer>
			<div class="d-flex justify-content-end">
				<TheLoading v-if="isLoading"></TheLoading>

				<Button class="p-button-text p-button-sm" label="No" icon="pi pi-times" @click="cancel" />
				<Button class="p-button-sm" label="Yes" icon="pi pi-check" @click="confirm" :disabled="v$.returnObj.remarks.$invalid" />
			</div>
		</template>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent } from "vue";

	import TheLoading from "@/components/TheLoading.vue";

	import useVuelidate from "@vuelidate/core";
	import { required, requiredIf } from "@vuelidate/validators";

	export default defineComponent({
		components: {
			TheLoading
		},
		data() {
			return {
				isVisible: false,
				isLoading: false,
				returnObj: {status: '', remarks: ''},
			}
		},
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				required: true,
			},
			header: {
				type: String,
				required: false
			},
			icon: {
				type: String,
				required: false
			},
			message: {
				type: String,
				required: true
			},
			withRemarks: {
				type: Boolean,
				required: false
			},
			isOptionalRemarks: {
				type: Boolean,
				required: false
			},
            status:{
                type: String,
                required: true
            }
		},
		watch: {
			visible(newValue: any) {
				this.isVisible = newValue;
				this.returnObj.remarks = '';
			},
			loading(newValue: any) {
				this.isLoading = newValue;
			},
            status(newValue: any){
                this.returnObj.status = newValue;
            }
		},
		methods: {
			confirm() {
				this.isLoading = true;

				if (this.withRemarks) {
					this.$emit('confirm', this.returnObj);
				}

				else {
					this.$emit('confirm', null);
				}
			},
			cancel() {
				this.$emit('cancel');
			}
		},
		setup() {
			return {v$: useVuelidate()}
		},
		validations() {
			return {
				returnObj: {
					remarks: {
						required: requiredIf(this.withRemarks && !this.isOptionalRemarks)
					}
				},
			}
		},
	});
</script>